import { useId } from "react";

export const PortfolioPrism = ({ id }) => {
  const gradient = `pf-prism-${useId().replace(/:/g, "")}`;
  return (
    <div className="pf-lucky-prism" aria-hidden="true" data-testid={`portfolio-card-${id}-prism`}>
      <svg className="pf-lucky-prism__border" focusable="false">
        <defs><linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#8effbd" /><stop offset="30%" stopColor="#a3e8ff" />
          <stop offset="55%" stopColor="#bdadff" /><stop offset="75%" stopColor="#ffd591" /><stop offset="1" stopColor="#9cffca" />
        </linearGradient></defs>
        <rect x="1" y="1" rx="7" pathLength="100" stroke={`url(#${gradient})`} />
      </svg>
      <span className="pf-lucky-prism__sheen" />
      <span className="pf-lucky-prism__crown" />
      {[0, 1, 2].map((i) => <i key={i} className="pf-lucky-prism__dust" style={{ "--dust": i }} />)}
    </div>
  );
};